// extracted by mini-css-extract-plugin
export default {"wrapper":"a78Pj","external":"b78Pj","title":"c78Pj","hint":"d78Pj"};